export const API_URL = {
  /* START: auth service */
  // auth
  signin: "/user/v1/login",
  signup: "/user/v1/register",
  updatePassword: "/user/v1/password",
  getMe: "/user/v1/prifile",
  loginWithToken: "/user/v1/login-alternative-keycloak",

  // forgotPassword: "/authentication-service/v1/forget-passwrod",
  // changePassword: "/authentication-service/v1/change-password",
  // resetPassword: "/authentication-service/v1/reset-password",
  // getLocation: "/authentication-service/v1/location", //   geo vul ase
  // updateCompleteProfile: "/authentication-service/v1/employee-profile-complete",
  // profileUpdate: "/authentication-service/v1/profile-update",
  // companyProfileUpdate: "/authentication-service/v1/company-profile-update",
  // sendVerificationEmail: "/authentication-service/v1/send-verification-email",
  // verifyEmail: "/authentication-service/v1/verify-email",

  // company
  getAllCompanyForDepartment: "/departments/v1/user-company",

  // ticket
  checkTemplateKeyAvailability: "/tickets/v1/is-template-key-exists",
  createTicket: "/tickets/v1/create",
  updateTicket: "/tickets/v1/update",
  getAllTickets: "/tickets/v1/get-tickets",
  raiseTicket: "/tickets/v1/raise-ticket",
  updateRaisedTicket: "/tickets/v1/edit-raised-ticket",
  reopenTicket: "/tickets/v1/reopen",
  getTicketDetails: "/tickets/v1/get-ticket",
  createCategory: "/tickets/v1/create-category",
  updateCategory: "/tickets/v1/update-category",
  getAllCategories: "/tickets/v1/get-categories",
  uploadPhoto: "tickets/v1/update-photo",
  myRaisedTickets: "tickets/v1/my-raised-tickets",
  getAllTicketLogs: "/tickets/v1/get-all-ticket-logs",
  getApprovalHubTickets: "/tickets/v1/get-ticket-logs-based-on-emp-workflow",
  getTicketLogDetails: "/tickets/v1/get-ticket-log-details",
  approveRaiseTicket: "/tickets/v1/approve-ticket-log",
  rejectRaiseTicket: "/tickets/v1/reject-ticket-log",
  shiftPriority: "/tickets/v1/update-raised-ticket-priority",
  getTicketLogsDetails: "/tickets/v1/get-ticket-log-details",
  getTicketLogActivity: "/tickets/v1/get-ticket-log-activity",
  addCc: "/tickets/v1/add-ticket-log-cc",
  getEmployeeListToAddCC: "/tickets/v1/get-employee-list-to-add-cc",
  cancelTicket: "/tickets/v1/tickets",
  getTicketIDRelatedNotifications: "/notifications/v1/notifications/details",
  getTicketForCC: "/tickets/v1/ticket-log-cc",
  updateTicketStatus: "/tickets/v1/update-status",
  closeTicket: "/tickets/v1",
  getTags: "/tickets/v1/tags/list",
  updateForwardTicket: "/tickets/v1/forwart-ticket-log",
  deleteTicket: "/tickets/v1/delete-ticket",
  forwardOpenTicket: "/tickets/v1/forward-open-ticket-log",
  resolveOpenTicket: "/tickets/v1/resolve-forwarded-ticket-log",
  getOneToOneChatList: "/chat/v1/one-to-one-chat-list",
  getOneToOneConversation: "/chat/v1/get-convertion-of-one-to-one-chat",
  getGroupConversation: "chat/v1/group-chat-conversion",
  getMailList: "/mail/v1/list",
  getSingleMailById: "/mail/v1/get",
  sendMail: "/mail/v1/send",
  getUserByEmail: "/mail/v1/get-user-by-email",
  replyMail: "/mail/v1/reply",
  getReplyMailByParentMail: "/mail/v1/get-reply-email",
  starredMail: "/mail/v1/star",
  deleteMail: "/mail/v1/delete",
  deleteMultipleMail: "/mail/v1/delete-multiple-mails",
  addSaveDraftMail: "/mail/v1/save-draft",
  updateSaveDraftMail: "/mail/v1/draft",
  getGroupChatDetails: "/chat/v1/get-group-chat-details",
  updateRead: "/mail/v1/mark-as-read",

  // comment
  addComment: "/ticket-log-comments/v1/add",
  editComment: "/ticket-log-comments/v1/edit-comment",
  deleteComment: "/ticket-log-comments/v1/delete-comment",
  getCommentHistory: "/ticket-log-comments/v1/get-comments-history",

  // employee management
  getRoleList: "/employees/v1/employee-role/list",
  updateEmployee: "/employees/v1/update",
  fileUpload: "/employees/v1/update-photo",

  // department
  createDepartment: "/departments/v1/create",
  updateDepartment: "/departments/v1/update",
  statusUpdate: "/departments/v1/update-status",
  getAllDepartment: "/departments/v1/list",
  getDepartmentById: "/departments/v1/details",

  // sub department
  createSubDepartment: "/sub-departments/v1/create",
  updateSubDepartment: "/sub-departments/v1/update",
  updateSubDepartmentStatus: "/sub-departments/v1/update",
  getAllSubDepartment: "/sub-departments/v1/list",
  getSubDepartmentById: "/sub-departments/v1/details",
  getSubDepartmentByIdGroupChat: "/sub-departments/v1/get-by-department",

  // employee
  createEmployee: "/employees/v1/create",
  updateEmployeeById: "/employees/v1/update",
  getAllEmployees: "/employees/v1/data",
  getEmployeeDetails: "/employees/v1/details",
  profile: "/employees/v1/prifile",
  updateEmployeeStatus: "/employees/v1/update-status",
  uploadProfilePicture: "/employees/v1/update-profile-picture",
  createRole: "/employees/v1/employee-role/create",
  getEmployeeBasedOnRole: "/employees/v1/get-employee-based-on-role",
  getUserList: "/tickets/v1/get-user-list",
  giveReportDownloadPermission: "/employees/v1/give-report-download-access",

  // Dashboard
  getAllTicketCount: "/tickets/v1/count",
  getTicketCountByStatus: "/tickets/v1/count-by-status",
  getTicketCountByRole: "/tickets/v1/count-role-types",
  getTicketRaisedWithTime: "/tickets/v1/count-raised-tickets-with-avg-time",
  getDashboardData: "/tickets/v1/get-dashboard-data",
  getDashboardGraphData: "/tickets/v1/admin-dashboard-graph-data",
  states: "/tickets/v1/my-ticket-dashboard-stats",
  statesByClick: "/tickets/v1/get-ticket-count-based-on-card-click",
  organizationStates: "/tickets/v1/organization-ticket-dashboard-stats",
  getTopPerformers: "/tickets/v1/top-performers",
  getCountApproved: "/tickets/v1/count-approver-done-status",
  getAverageCompletion: "/tickets/v1/average-completion-time",
  graphData: "/tickets/v1/dashboard-graph-data-alternative",
  getMyDepartmentStates: "/tickets/v1/department-ticket-log-stats",
  // Chat
  getChatUserList: "/chat/v1/get-user-list",
  createGroupChat: "/chat/v1/create-group-chat",
  addGroupPhoto: "/chat/v1/update-group-chat-photo",
  addGroupName: "/chat/v1/update-group-chat-name",
  addGroupMember: "/chat/v1/add-user-to-group-chat",
  getGroupMember: "/chat/v1/get-group-chat-member-list",
  leaveFromGroup: "/chat/v1/leave-group",
  getGroupAttachments: "/chat/v1/get-group-attachment-data",
  getChatAttachments: "/chat/v1/get-attachment-data-of-chat",
  updateGroupName: "/chat/v1/update-group-chat-name",
  updateGroupPhoto: "/chat/v1/update-group-chat-photo",
  getFilterGroupUser: "/chat/v1/get-user-to-add-to-group-chat",
  updateGroupMember: "/chat/v1/add-user-to-group-chat",
  deleteSpecificMessage: "/chat/v1/delete-a-specific-message",
  deleteAllChat: "/chat/v1/leave-one-to-one-chat",

  // Notification
  notification: "/notifications",
  notificationCount: "/notifications/v1/count",
  checkNotification: "/notifications/v1",
  checkNotifications: "/notifications/v1/multiple-check",

  // Products
  createProduct: "/product/v1/create",
  updateProduct: "/product/v1/update",
  updateProductStatus: "/product/v1/change-status",
  getAllProduct: "/product/v1/all",
  getProductDetails: "/product/v1/get-single",

  // Feature
  createFeature: "/feature/v1/create",
  updateFeature: "/feature/v1/update",
  updateFeatureStatus: "/feature/v1/change-status",
  getAllFeature: "/feature/v1/all",
  getFeatureDetails: "/feature/v1/get-single",

  // Reports
  getAllReports: "/ticket-report/v1/all-reports",
  generateReport: "/ticket-report/v1/generate-report",
};
